import { Api } from '../plugins/axios'

import { initializeApp } from 'firebase/app';
import {  getMessaging, getToken, onMessage, isSupported} from 'firebase/messaging';

let projectId = "nxlead-notifications";

const firebaseConfig = {
    apiKey: "AIzaSyB6n1pYrwLwSV4y6oeKuhqSSjvcuYjhbMU",
    authDomain: projectId + ".firebaseapp.com",
    databaseURL: "https://" + projectId + ".firebaseio.com",
    projectId: projectId,
    storageBucket: projectId + ".appspot.com",
    messagingSenderId: "86110662743",
    appId: "1:86110662743:web:ea4bf2263e27786fc3f312"
  };
let firebaseApp = initializeApp(firebaseConfig)
let messaging = null

async function checkFCMSupport() {
  const supported = await isSupported();

  if (supported) {
    messaging = getMessaging(firebaseApp); 
  }
}

checkFCMSupport();

export default messaging;
var serviceWorkerRegistrationObject = null;
export function onMountCall(){

  if(messaging){  

    if('Notification' in window){
      if (Notification.permission != 'granted' && Notification.permission != 'denied') {
        
        // we need the click event to ask for permissions for the browsers like firefox
        var listener = (event) => {
          
          if(Notification.permission != 'granted'){
            askForNotificationPermissions()
          }
          

          window.removeEventListener('click', listener);
        }
        
        window.addEventListener('click', listener);
        
      }
    }

    if ('serviceWorker' in navigator) {  
      
      navigator.serviceWorker.register('/firebase-messaging-sw.js?v=v2')    
      .then((registration) => { 

        if(registration?.active?.state === 'activated'){
          serviceWorkerRegistrationObject = registration;
          subscribeToFcm()      
        }
          
      }).catch(function(err) { 
          console.log('Service worker registration failed, error:', err); 
      }); 
    }

    onMessage(messaging, (data) => {
      data?.stopImmediatePropagation?.();

      let notification = data['notification'];
      let link = data?.data?.link;
      if(notification?.title){
        let notif = new Notification(notification.title, {
          body: notification.body,
          icon: notification.icon,
          link: link,
          click_action: link,
          url: link
        });

        notif.onclick = (event) => {
          event.preventDefault(); // prevent the browser from focusing the Notification's tab
          event.stopImmediatePropagation();
          event.stopPropagation();

          event?.notification?.close?.()
          window.open(link, "_blank");

        };
      }
        
      });
    // }
  }
}

async function saveToken(token) {
  let {data: {firebaseToken, message, errors}, status} = await Api.post('/api/v1/firebase-tokens/add', {token, type: 'web' }).catch(e => e)
}


function checkAndUpdateToken() {

  
  if(!serviceWorkerRegistrationObject) {
    console.log('service worker registration object not available to use')
    return false;
  }
  // Check if the token is still valid (for example, if local storage is cleared)
  const storedToken = localStorage.getItem('fcmToken');
  getToken(messaging, { serviceWorkerRegistration: serviceWorkerRegistrationObject, vapidKey: process.env.MIX_FIREBASE_VAPID_KEY })
      .then((currentToken) => {
          if (!currentToken || currentToken !== storedToken) {
              // Token is not available or has changed
              // Update the token on the server
              saveToken(currentToken);
              // Store the updated token in local storage
              localStorage.setItem('fcmToken', currentToken);
          }
      })
      .catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
      });
}

function subscribeToFcm(){
  
  if( !('Notification' in window) ){
    console.log('Notification not found in window object')
    return false;
  }

  if (Notification.permission === 'granted') {
    checkAndUpdateToken()
  } else{
    // here we ask for the notifications as we know that permission in the default state so we can go ahead ask user for permissions
    askForNotificationPermissions()
  }
}

function askForNotificationPermissions(){
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      // we call this method again as now we know that permission is granted so it would get token and save it
      subscribeToFcm();
    } else {
      console.log('Unable to get permission to notify.');
    }
  });
}
